import type { SVGProps } from 'react';

export const TextItalicsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4004 6.59961C14.7826 6.59973 15.1422 6.78253 15.3682 7.09082C15.594 7.39913 15.659 7.79668 15.5439 8.16113L12.4365 18H14.4004C15.063 18.0002 15.5996 18.5376 15.5996 19.2002C15.5995 19.8627 15.0629 20.4002 14.4004 20.4004H7.2002C6.53752 20.4004 6.00011 19.8628 6 19.2002C6 18.5375 6.53745 18 7.2002 18H9.9209L12.7627 9H10.7998C10.1372 8.99989 9.59961 8.46248 9.59961 7.7998C9.59971 7.13722 10.1372 6.59971 10.7998 6.59961H14.4004ZM15.5996 1.7998C16.428 1.7998 17.0995 2.47147 17.0996 3.2998C17.0996 4.12823 16.428 4.7998 15.5996 4.7998C14.7714 4.79959 14.0996 4.1281 14.0996 3.2998C14.0997 2.4716 14.7714 1.80002 15.5996 1.7998Z"
      fill="currentColor"
    />
  </svg>
);
